import { render, staticRenderFns } from "./Loadingscreen.vue?vue&type=template&id=44305633&"
import script from "./Loadingscreen.vue?vue&type=script&lang=js&"
export * from "./Loadingscreen.vue?vue&type=script&lang=js&"
import style0 from "./Loadingscreen.vue?vue&type=style&index=0&id=44305633&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports